import { Button as MuiButton } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

const Button = forwardRef(({ className, error, ...props }, ref) => {
  const { css, cx, theme } = useStyles();

  return (
    <MuiButton
      ref={ref}
      className={cx(
        css({
          ...(error && {
            background: theme.palette.error.main,
            '&:hover': {
              background: theme.palette.error.dark,
            },
          }),
        }),
        className
      )}
      {...props}
    />
  );
});

Button.propTypes = {
  error: PropTypes.bool,
  className: PropTypes.string,
};

export default Button;
